import { transport } from 'config/transport';

export function callApiExportCongDoanVungMonthlyReport(congDoanId, yearMonth, pdf = false, submitToTW = false) {
    return transport.get(`/congdoanvung/${congDoanId}/thuchi/exportReport`, { params: { yearMonth, pdf, submitToTW }, responseType: 'blob' });
}
